import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { GnomadExomes, GnomadGenomes, GnomadMito } from "./gnomad";
import GnomadCoverage from "./GnomadCoverage";
import Kaviar from "./Kaviar";
import Bravo from "./Bravo";
import {
  getGnomadExomes,
  getGnomadExomesCoverage,
  getGnomadGenomes,
  getGnomadGenomesCoverage,
  getIsbKaviar3,
  getBravo,
  getGnomadMito,
} from "../../../../state/selectors/Frequencies.selectors";
import {
  getLoading,
  getError,
  getIfVariantResultExists,
  getChromosome,
} from "../../../../state/selectors/general.selectors";
import HelperText from "../../../../components/atoms/HelperText";

const Frequencies = (props) => {
  let content = null;
  const {
    gnomadExomes,
    gnomadExomesCoverage,
    gnomadGenomes,
    gnomadGenomesCoverage,
    isbKaviar3,
    bravo,
    loading,
    error,
    variantResult,
    gnomadMito,
    chromosome,
  } = props;
  const showMito = chromosome === "MT" || chromosome === "chrM";
  if (loading || error || !variantResult) {
    return null;
  }

  if (
    gnomadExomes ||
    gnomadExomesCoverage ||
    gnomadGenomes ||
    gnomadGenomesCoverage ||
    isbKaviar3 ||
    bravo ||
    gnomadMito
  ) {
    content = (
      <div
        className="tw-overflow-x-auto varsome-inner-container"
        data-testid="frequencies-components-container"
      >
        <GnomadExomes />
        <GnomadCoverage gnomadType="exomes" title="gnomAD Exomes Coverage" />
        <GnomadGenomes />
        <GnomadCoverage gnomadType="genomes" title="gnomAD Genomes Coverage" />
        {showMito && <GnomadMito />}
        <Kaviar />
        <Bravo />
      </div>
    );
  } else {
    content = (
      <div
        className="varsome-inner-container"
        data-testid="frequencies-no-data"
      >
        No data available for this variant in gnomAD Exomes, gnomAD Genomes,
        {showMito && " gnomAD Mitochondrial,"} ISB Kaviar3 and Bravo.
      </div>
    );
  }
  return (
    <div className="varsome-result-fixed">
      <div className="varsome-container varsome-container__basic">
        <div className="varsome-title tw-font-semibold">
          Frequencies
          <HelperText fieldDescriptionKey="Frequencies" />
        </div>
        {content}
      </div>
    </div>
  );
};

Frequencies.propTypes = {
  gnomadExomes: PropTypes.arrayOf(PropTypes.shape({})),
  gnomadExomesCoverage: PropTypes.arrayOf(PropTypes.shape({})),
  gnomadGenomes: PropTypes.arrayOf(PropTypes.shape({})),
  gnomadGenomesCoverage: PropTypes.arrayOf(PropTypes.shape({})),
  isbKaviar3: PropTypes.arrayOf(PropTypes.shape({})),
  bravo: PropTypes.arrayOf(PropTypes.shape({})),
  loading: PropTypes.bool,
  error: PropTypes.shape({}),
  variantResult: PropTypes.bool,
  gnomadMito: PropTypes.arrayOf(PropTypes.shape({})),
  chromosome: PropTypes.string,
};

Frequencies.defaultProps = {
  gnomadExomes: null,
  gnomadExomesCoverage: null,
  gnomadGenomes: null,
  gnomadGenomesCoverage: null,
  isbKaviar3: null,
  bravo: null,
  loading: false,
  error: null,
  variantResult: false,
  gnomadMito: null,
  chromosome: "",
};

const mapStateToProps = (state) => ({
  gnomadExomes: getGnomadExomes(state),
  gnomadExomesCoverage: getGnomadExomesCoverage(state),
  gnomadGenomes: getGnomadGenomes(state),
  gnomadGenomesCoverage: getGnomadGenomesCoverage(state),
  isbKaviar3: getIsbKaviar3(state),
  bravo: getBravo(state),
  loading: getLoading(state),
  error: getError(state),
  variantResult: getIfVariantResultExists(state),
  gnomadMito: getGnomadMito(state),
  chromosome: getChromosome(state),
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Frequencies);
